import { useWindowSize } from 'react-use';
import { isBrowser } from '@web3/base-utils';

export const getScreenType = (
  width: number = isBrowser ? window.innerWidth : 0,
  height: number = isBrowser ? window.innerHeight : 0
) => {
  return {
    isMobile: width <= 640,
    isMd: width > 768 && width <= 1200,
    isXl: width > 1200,
    height,
    width,
  };
};

export const initialWindowType = getScreenType();

export const useScreenType = () => {
  const { width, height } = useWindowSize();
  return getScreenType(width, height);
};
